import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQToggleMenu from '../../components/togglemenu';
import UQSpacer from '../../components/spacer';
import UQCode from '../../components/code';
import { BREADCRUMB_ROOT } from '../../common/config';

const ToggleMenuDemoPage = () => {
  const menuItems = [
    { text: 'Profile', icon: 'user' },
    { text: 'Settings', icon: 'settings' },
    { text: 'Logout', icon: 'logout', disabled: true },
  ];

  const defaultToggleMenuCode = `
<UQToggleMenu
  items={[
    { text: 'Profile', icon: 'user' },
    { text: 'Settings', icon: 'settings' },
    { text: 'Logout', icon: 'logout', disabled: true },
  ]}
  triggerElement={<button>Open Menu</button>}
/>
`;

  const fixedPositionToggleMenuCode = `
<UQToggleMenu
  items={[
    { text: 'Profile', icon: 'user' },
    { text: 'Settings', icon: 'settings' },
    { text: 'Logout', icon: 'logout', disabled: true },
  ]}
  triggerElement={<button>Open Menu (Right)</button>}
  position="right"
/>
`;

  return (
    <>
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Toggle Menu']} />
      <h1>UQToggleMenu Demo</h1>
      <UQSpacer size="m" />

      {/* Description */}
      <h2>Description</h2>
      <p>
        The <code>UQToggleMenu</code> component is a flexible menu system that allows you to toggle a menu when clicking on a trigger element. It supports dynamic positioning based on available space or fixed positions like <code>left</code>, <code>right</code>, <code>top</code>, and <code>bottom</code>. Disabled menu items are also supported.
      </p>
      <UQSpacer size="m" />

      {/* Attributes Table */}
      <h2>Attributes</h2>
      <table className="uq-attributes-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Type</th>
            <th>Default</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>items</code></td>
            <td><code>UQToggleMenuItem[]</code></td>
            <td><code>[]</code></td>
            <td>An array of menu items to display.</td>
          </tr>
          <tr>
            <td><code>triggerElement</code></td>
            <td><code>React.ReactNode</code></td>
            <td><code>null</code></td>
            <td>The element that toggles the menu.</td>
          </tr>
          <tr>
            <td><code>position</code></td>
            <td><code>'left' | 'right' | 'top' | 'bottom'</code></td>
            <td><code>null</code></td>
            <td>Optional fixed position for the menu.</td>
          </tr>
          <tr>
            <td><code>onItemClick</code></td>
            <td><code>(item: UQToggleMenuItem) ={'>'} void</code></td>
            <td><code>undefined</code></td>
            <td>Callback function triggered when a menu item is clicked.</td>
          </tr>
          <tr>
            <td><code>className</code></td>
            <td><code>string</code></td>
            <td><code>''</code></td>
            <td>Additional class names for custom styling.</td>
          </tr>
        </tbody>
      </table>
      <UQSpacer size="m" />

      {/* Live Demo */}
      <h2>Live Demo</h2>
      <h3>Default Toggle Menu</h3>
      <UQSpacer size="s" />
      <UQToggleMenu
        items={menuItems}
        triggerElement={<button>Open Menu</button>}
      />
      <UQSpacer size="s" />
      <UQCode code={defaultToggleMenuCode} enableCopy />
      <UQSpacer size="m" />

      <h3>Toggle Menu with Fixed Position</h3>
      <UQSpacer size="s" />
      <UQToggleMenu
        items={menuItems}
        triggerElement={<button>Open Menu (Right)</button>}
        position="right"
      />
      <UQSpacer size="s" />
      <UQCode code={fixedPositionToggleMenuCode} enableCopy />
    </>
  );
};

export default ToggleMenuDemoPage;